import { useState, useMemo } from 'react';
import { Combobox } from '@headlessui/react';
import {
    AutocompleteSearch,
    FilterProps,
    LeftFilterProps,
} from 'types/Filters';
import CheckboxList from 'views/HomePage/Components/CheckboxList';

interface AutocompleteCheckboxProps {
    items: LeftFilterProps[];
    placeholder: string;
    section: string;
    setLeftFilter: React.Dispatch<React.SetStateAction<FilterProps[]>>;
    updateHomepageFilter: (
        updatedOption: LeftFilterProps,
        filterId: string,
    ) => void;
}

export default function AutocompleteCheckbox({
    items,
    placeholder,
    section,
    setLeftFilter,
    updateHomepageFilter,
}: AutocompleteCheckboxProps) {
    const [searchTerm, setSearchTerm] = useState('');
    const filteredItems = useMemo(() => {
        if (searchTerm === '') {
            return items;
        } else {
            return items?.filter((item) => {
                return item.label
                    .toLowerCase()
                    .includes(searchTerm.toLowerCase());
            });
        }
    }, [searchTerm, items]);

    return (
        <div className="relative mb-12">
            <Combobox>
                <div className="flex">
                    <Combobox.Input
                        onChange={(e) => setSearchTerm(e.target.value)}
                        displayValue={(item: AutocompleteSearch) => item.label}
                        value={searchTerm}
                        placeholder={placeholder}
                        className="autocomplete-search-bar-input rounded-8"
                    />
                </div>
                <Combobox.Options className="search-bar-div py-16 rounded-8">
                    <CheckboxList
                        options={filteredItems}
                        section={section}
                        dropdown={true}
                        setSearchTerm={setSearchTerm}
                        setLeftFilter={setLeftFilter}
                        updateHomepageFilter={updateHomepageFilter}
                    />
                </Combobox.Options>
            </Combobox>
        </div>
    );
}
